import _ from '@lodash';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Tooltip, Icon, IconButton } from '@material-ui/core';
import nBossConnection from 'modules/base/service/nBossConnection';

function TableToolbarSeparatedXLSButton(props) {
	const dispatch = useDispatch();
	const filterList = useSelector(rootState => rootState.vizsgazoTable.tableBrowserFilter.filterList);
	const vizsgaVizsgazo = filterList.find(item => item.propertyName === 'vizsgaVizsgazo');

	const handleClick = () => {
		if (_.isUndefined(vizsgaVizsgazo)) {
			dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
		}
	};
	console.log(vizsgaVizsgazo);
	return (
		<Tooltip title="Bontott Export">
			<IconButton onClick={() => handleClick()} component="a" href={vizsgaVizsgazo ? `${nBossConnection.basePath}/vizsgazoControl/createSeparatedXLS?examId=${vizsgaVizsgazo.value}` : null} target="_blank">
				<Icon fontSize="small">exit_to_app</Icon>
			</IconButton>
		</Tooltip>
	);
}

export default TableToolbarSeparatedXLSButton;
